// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__8vdxC","ellipsis":"styles_ellipsis__e7Gvp","text2AndMoreLines":"styles_text2AndMoreLines__PE42c","tooltipTrigger":"styles_tooltipTrigger__vXFGY"};